
import { CheckCircle, XCircle } from "lucide-react";

interface ComparisonItem {
  capability: string;
  spharakaXDR: boolean | string;
  traditionalSIEM: boolean | string;
  standaloneEDR: boolean | string;
}

const ComparisonSection = () => {
  const comparisonData: ComparisonItem[] = [
    {
      capability: "Unified Cross-Domain Visibility",
      spharakaXDR: true,
      traditionalSIEM: false,
      standaloneEDR: false
    },
    {
      capability: "Agentic AI-Powered Analytics",
      spharakaXDR: true,
      traditionalSIEM: false,
      standaloneEDR: false
    },
    {
      capability: "Automated Response Capabilities",
      spharakaXDR: true,
      traditionalSIEM: false,
      standaloneEDR: "limited"
    },
    {
      capability: "Cloud Workload Protection",
      spharakaXDR: true,
      traditionalSIEM: "limited",
      standaloneEDR: false
    },
    {
      capability: "Identity-Based Threat Detection",
      spharakaXDR: true,
      traditionalSIEM: "limited",
      standaloneEDR: false
    },
    {
      capability: "Zero Trust Architecture Support",
      spharakaXDR: true,
      traditionalSIEM: false,
      standaloneEDR: false
    },
    {
      capability: "Operational Efficiency Impact",
      spharakaXDR: "High Positive",
      traditionalSIEM: "Negative",
      standaloneEDR: "Neutral"
    },
    {
      capability: "Total Cost of Ownership",
      spharakaXDR: "Lower",
      traditionalSIEM: "Higher",
      standaloneEDR: "Medium"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Why Choose <span className="text-spharaka-purple">Spharaka Autonomous Cyber Defence Platform</span>?</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            See how Spharaka Autonomous Cyber Defence Platform compares to traditional security solutions
          </p>
        </div>

        <div className="max-w-5xl mx-auto overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="py-4 px-6 text-left font-semibold">Capabilities</th>
                <th className="py-4 px-6 text-center bg-spharaka-purple/10 font-semibold">Spharaka Autonomous Cyber Defence Platform</th>
                <th className="py-4 px-6 text-center font-semibold">Traditional SIEM</th>
                <th className="py-4 px-6 text-center font-semibold">Standalone EDR</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) => (
                <tr key={index} className="border-t border-gray-200">
                  <td className="py-4 px-6 font-medium">{row.capability}</td>
                  <td className="py-4 px-6 text-center bg-spharaka-purple/10">
                    {row.spharakaXDR === true ? (
                      <CheckCircle className="h-5 w-5 text-spharaka-purple mx-auto" />
                    ) : row.spharakaXDR === false ? (
                      <XCircle className="h-5 w-5 text-red-500 mx-auto" />
                    ) : (
                      row.spharakaXDR
                    )}
                  </td>
                  <td className="py-4 px-6 text-center">
                    {row.traditionalSIEM === true ? (
                      <CheckCircle className="h-5 w-5 text-green-500 mx-auto" />
                    ) : row.traditionalSIEM === false ? (
                      <XCircle className="h-5 w-5 text-red-500 mx-auto" />
                    ) : (
                      row.traditionalSIEM
                    )}
                  </td>
                  <td className="py-4 px-6 text-center">
                    {row.standaloneEDR === true ? (
                      <CheckCircle className="h-5 w-5 text-green-500 mx-auto" />
                    ) : row.standaloneEDR === false ? (
                      <XCircle className="h-5 w-5 text-red-500 mx-auto" />
                    ) : (
                      row.standaloneEDR
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
